import React from "react";
import { styled } from "@mui/system";
import MUIAccordionDetails from "@mui/material/AccordionDetails";
import { AccordionDetailsProps as AccordionDetailsPropsMUI } from "@mui/material/AccordionDetails";
export interface AccordionDetailsProps extends AccordionDetailsPropsMUI {}

export const AccordionDetails: (props: AccordionDetailsProps) => JSX.Element =
  styled(
    React.forwardRef<HTMLElement, AccordionDetailsProps>((props, ref) => (
      <MUIAccordionDetails ref={ref} {...props} />
    )),
    {
      name: "AccordionDetails",
      slot: "Root",
      overridesResolver: (props, styles) => []
    }
  )(({ theme }) => ({
    "&.MuiAccordionDetails-root": {
      paddingLeft: 45,
      paddingRight: 48,
      background: theme.palette.primary.surfaceDefault
    }
  }));
